import pipeline from '@/pipeline';
import Analytics from './analytics';
import { PartnerData } from '@/types/partner';

export enum Provider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
  DESCOMPLICA = 'descomplica',
}

export enum ProductName {
  UNDERGRAD_DESCOMPLICA = 'undergrad',
}

export enum SignTabs {
  SignIn = 'signin',
  SignUp = 'signup',
}

export interface LoginWithIframeData {
  url: any;
  email: string;
  phone?: string;
  hideTabs?: SignTabs[];
  hideSocialButtons?: Provider[];
  productName?: ProductName;
  hideSocialMedia?: boolean;
  hideHeaders?: boolean;
  hideFooter?: boolean;
  hidePassword?: boolean;
  disableEmail?: boolean;
  disablePhone?: boolean;
  onSuccess?: () => void;
  onError?: () => void;
}

const loginWithIframe = (
  params: LoginWithIframeData,
  elementToEmbedIn: string,
  classToAdd: string,
) => {
  if (window.POCKET) {
    window.POCKET.Auth.loginWithIframe({
      onSuccess: () => {
        pipeline.next();
        Analytics.identify({ id: params.email, email: params.email });
      },
      ...params,
    });

    const authIframeContainer = document.querySelector('.authIframeContainer');
    const content = document.querySelector(elementToEmbedIn);

    if (content && authIframeContainer) {
      authIframeContainer.classList.add(classToAdd);
      content.appendChild(authIframeContainer);
    }
  }
};

const getTokenD = (): string | undefined => {
  const profile = window.POCKET.profile();
  return profile ? profile.d : undefined;
};

const isLogged = (): boolean => {
  if (!window.POCKET) {
    return false;
  }

  return !!getTokenD();
};

const logout = (): boolean => {
  if (!window.POCKET) {
    return false;
  }

  window.POCKET.profile.logout();

  return !isLogged();
};

const getPartnerDataFromCookie = (cookieName: string): PartnerData | null => {
  if (typeof window === 'undefined' || !window.POCKET) return null;

  return window.POCKET.getPartnerDataFromCookie(cookieName);
};

export default {
  loginWithIframe,
  isLogged,
  logout,
  getTokenD,
  getPartnerDataFromCookie,
};
